import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimCacheFile extends BaseModel {
    @Expose() id = -1;
    @Expose() link = "";
    @Expose() type = ""; // category
    @Expose() name = "";
    @Expose() coverageIds = "";
    @Expose() originalName = "";
}
